module.exports = __webpack_public_path__ + "media/images/flags/ps-f35f0e9251b322376f67ef74fa44fa98.svg";